import { render, staticRenderFns } from "./Assessmenttaskmange.vue?vue&type=template&id=ea4cf664&scoped=true"
import script from "./Assessmenttaskmange.vue?vue&type=script&lang=js"
export * from "./Assessmenttaskmange.vue?vue&type=script&lang=js"
import style0 from "./Assessmenttaskmange.vue?vue&type=style&index=0&id=ea4cf664&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4cf664",
  null
  
)

export default component.exports